import React from "react";

import EDeliveryInlineView from "./EDeliveryInlineView";

interface EDeliveryContainerProps {
    action: (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>,
        selectedValue: string | null,
        isEmailRequired: boolean
    ) => void;
    eDeliveryInitData: {
        allowedToOverwrite: string;
        docTypes: string;
        eDeliveryOption: string;
        econsentemailAddress: string | null;
        isAtleaseOneActiveThere: string;
        planName: string;
        pptConsent: string;
        secondaryEmailAddress: string | null;
    };
}

const EDeliveryInlineViewContainer = (props: EDeliveryContainerProps) => {
    return <EDeliveryInlineView {...props} />;
};

export default EDeliveryInlineViewContainer;
